import { truncateAddress } from "@/utils";
import { useWalletBalances } from "@/hooks";

export function ConnectedAddress({
    ensName,
    address,
    className,
}: {
    ensName: string | null;
    address: string;
    className?: string;
}) {
    const { isLoading: isLoadingBalances, isSuccess } = useWalletBalances();

    return (
        <div
            className={`relative inline-flex items-center hover:brightness-75 transition-all duration-300 ${className ?? "text-primary"}`}
        >
            <span className="text-[12px] md:text-[15px] mr-4">{ensName || truncateAddress(address)}</span>
            {!isLoadingBalances && isSuccess && (
                <div className="absolute top-0 right-[10px] w-[5px] h-[5px] bg-blue-500 rounded-full animate-dot" />
            )}
        </div>
    );
}
